export default __webpack_public_path__ + "static/media/icon-podbean.2678afae.svg";